module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "blog-posts-area section-padding"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8 post-list blog-post-list"
  }, [_c('div', {
    staticClass: "single-post"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/assets/images/p1.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "tags"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Art")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Technology")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Fashion")])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('h2', [_vm._v("\n                Cartridge Is Better Than Ever\n                A Discount Toner\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "content-wrap"
  }, [_c('p', [_vm._v("\n                MCSE boot camps have its supporters and its detractors. Some people do not understand why you should have to spend money on boot camp when you can get the MCSE study materials yourself at a fraction of the camp price. However, who has the willpower to actually sit through a self-imposed MCSE training. who has the willpower to actually sit through a self-imposed MCSE training.\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                MCSE boot camps have its supporters and its detractors. Some people do not understand why you should have to spend money on boot camp when you can get the MCSE study materials yourself at a fraction of the camp price. However, who has the willpower to actually sit through a self-imposed MCSE training. who has the willpower to actually sit through a self-imposed MCSE training.\n              ")]), _vm._v(" "), _c('blockquote', {
    staticClass: "generic-blockquote"
  }, [_vm._v("\n                “Recently, the US Federal government banned online casinos from operating in America by making it illegal to transfer money to them through any US bank or payment system. As a result of this law, most of the popular online casino networks such as Party Gaming and PlayTech left the United States. Overnight, online casino players”\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                MCSE boot camps have its supporters and its detractors. Some people do not understand why you should have to spend money on boot camp when you can get the MCSE study materials yourself at a fraction of the camp price. However, who has the willpower to actually sit through a self-imposed MCSE training. who has the willpower to actually sit through a self-imposed MCSE training.\n              ")]), _vm._v(" "), _c('p', [_vm._v("\n                MCSE boot camps have its supporters and its detractors. Some people do not understand why you should have to spend money on boot camp when you can get the MCSE study materials yourself at a fraction of the camp price. However, who has the willpower to actually sit through a self-imposed MCSE training. who has the willpower to actually sit through a self-imposed MCSE training.\n              ")])]), _vm._v(" "), _c('section', {
    staticClass: "nav-area py-5"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-between"
  }, [_c('div', {
    staticClass: "col-sm-6 nav-left justify-content-start d-flex"
  }, [_c('div', {
    staticClass: "thumb"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/prev.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "post-details"
  }, [_c('p', [_vm._v("Prev Post")]), _vm._v(" "), _c('h4', {
    staticClass: "text-uppercase"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("A Discount Toner")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 nav-right justify-content-end d-flex"
  }, [_c('div', {
    staticClass: "post-details"
  }, [_c('p', [_vm._v("Prev Post")]), _vm._v(" "), _c('h4', {
    staticClass: "text-uppercase"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("A Discount Toner")])])]), _vm._v(" "), _c('div', {
    staticClass: "thumb"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/next.jpg",
      "alt": ""
    }
  })])])])])]), _vm._v(" "), _c('section', {
    staticClass: "comment-sec-area py-5"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row flex-column"
  }, [_c('h5', {
    staticClass: "text-uppercase pb-80"
  }, [_vm._v("05 Comments")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "comment-list"
  }, [_c('div', {
    staticClass: "single-comment justify-content-between d-flex"
  }, [_c('div', {
    staticClass: "user justify-content-between d-flex"
  }, [_c('div', {
    staticClass: "thumb"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/c1.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('h5', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Emilly Blunt")])]), _vm._v(" "), _c('p', {
    staticClass: "date"
  }, [_vm._v("December 4, 2017 at 3:12 pm ")]), _vm._v(" "), _c('p', {
    staticClass: "comment"
  }, [_vm._v("\n                            Never say goodbye till the end comes!\n                          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "reply-btn"
  }, [_c('a', {
    staticClass: "btn-reply text-uppercase",
    attrs: {
      "href": ""
    }
  }, [_vm._v("reply")])])])]), _vm._v(" "), _c('div', {
    staticClass: "comment-list left-padding"
  }, [_c('div', {
    staticClass: "single-comment justify-content-between d-flex"
  }, [_c('div', {
    staticClass: "user justify-content-between d-flex"
  }, [_c('div', {
    staticClass: "thumb"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/c2.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('h5', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Emilly Blunt")])]), _vm._v(" "), _c('p', {
    staticClass: "date"
  }, [_vm._v("December 4, 2017 at 3:12 pm ")]), _vm._v(" "), _c('p', {
    staticClass: "comment"
  }, [_vm._v("\n                            Never say goodbye till the end comes!\n                          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "reply-btn"
  }, [_c('a', {
    staticClass: "btn-reply text-uppercase",
    attrs: {
      "href": ""
    }
  }, [_vm._v("reply")])])])]), _vm._v(" "), _c('div', {
    staticClass: "comment-list left-padding"
  }, [_c('div', {
    staticClass: "single-comment justify-content-between d-flex"
  }, [_c('div', {
    staticClass: "user justify-content-between d-flex"
  }, [_c('div', {
    staticClass: "thumb"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/c3.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('h5', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Emilly Blunt")])]), _vm._v(" "), _c('p', {
    staticClass: "date"
  }, [_vm._v("December 4, 2017 at 3:12 pm ")]), _vm._v(" "), _c('p', {
    staticClass: "comment"
  }, [_vm._v("\n                            Never say goodbye till the end comes!\n                          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "reply-btn"
  }, [_c('a', {
    staticClass: "btn-reply text-uppercase",
    attrs: {
      "href": ""
    }
  }, [_vm._v("reply")])])])]), _vm._v(" "), _c('div', {
    staticClass: "comment-list"
  }, [_c('div', {
    staticClass: "single-comment justify-content-between d-flex"
  }, [_c('div', {
    staticClass: "user justify-content-between d-flex"
  }, [_c('div', {
    staticClass: "thumb"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/c4.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('h5', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Emilly Blunt")])]), _vm._v(" "), _c('p', {
    staticClass: "date"
  }, [_vm._v("December 4, 2017 at 3:12 pm ")]), _vm._v(" "), _c('p', {
    staticClass: "comment"
  }, [_vm._v("\n                            Never say goodbye till the end comes!\n                          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "reply-btn"
  }, [_c('a', {
    staticClass: "btn-reply text-uppercase",
    attrs: {
      "href": ""
    }
  }, [_vm._v("reply")])])])]), _vm._v(" "), _c('div', {
    staticClass: "comment-list"
  }, [_c('div', {
    staticClass: "single-comment justify-content-between d-flex"
  }, [_c('div', {
    staticClass: "user justify-content-between d-flex"
  }, [_c('div', {
    staticClass: "thumb"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/c5.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('h5', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Emilly Blunt")])]), _vm._v(" "), _c('p', {
    staticClass: "date"
  }, [_vm._v("December 4, 2017 at 3:12 pm ")]), _vm._v(" "), _c('p', {
    staticClass: "comment"
  }, [_vm._v("\n                            Never say goodbye till the end comes!\n                          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "reply-btn"
  }, [_c('a', {
    staticClass: "btn-reply text-uppercase",
    attrs: {
      "href": ""
    }
  }, [_vm._v("reply")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "commentform-area py-5"
  }, [_c('form', {
    attrs: {
      "action": "#"
    }
  }, [_c('div', {
    staticClass: "left"
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Enter your name",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Enter your name'",
      "required": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "email",
      "placeholder": "Enter email address",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Enter email address'",
      "required": ""
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Enter subject",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Enter subject'",
      "required": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('textarea', {
    attrs: {
      "name": "message",
      "cols": "20",
      "rows": "7",
      "placeholder": "Enter Message",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = 'Enter Message'",
      "required": ""
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "template-btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("subscribe now")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 sidebar mt-5 mt-lg-0"
  }, [_c('div', {
    staticClass: "single-widget search-widget"
  }, [_c('form', {
    staticClass: "example",
    staticStyle: {
      "margin": "auto",
      "max-width": "300px"
    },
    attrs: {
      "action": "#"
    }
  }, [_c('input', {
    attrs: {
      "type": "text",
      "placeholder": "Search Posts",
      "name": "search2"
    }
  }), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "single-widget protfolio-widget"
  }, [_c('img', {
    attrs: {
      "src": "static/assets/images/user2.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('h4', [_vm._v("Adele Gonzalez")])]), _vm._v(" "), _c('p', [_vm._v("\n              MCSE boot camps have its supporters and\n              its detractors. Some people do not understand why you should have to spend money\n              on boot camp.\n            ")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-facebook"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-dribbble"
  })])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-behance"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "single-widget category-widget"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Post Categories")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Techlology")]), _vm._v(" "), _c('span', [_vm._v("37")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Lifestyle")]), _vm._v(" "), _c('span', [_vm._v("24")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Fashion")]), _vm._v(" "), _c('span', [_vm._v("59")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Art")]), _vm._v(" "), _c('span', [_vm._v("29")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Food")]), _vm._v(" "), _c('span', [_vm._v("15")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Architecture")]), _vm._v(" "), _c('span', [_vm._v("09")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Adventure")]), _vm._v(" "), _c('span', [_vm._v("44")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "single-widget recent-posts-widget"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Recent Posts")]), _vm._v(" "), _c('div', {
    staticClass: "blog-list"
  }, [_c('div', {
    staticClass: "single-recent-post d-flex flex-row"
  }, [_c('div', {
    staticClass: "recent-thumb"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/assets/images/r1.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "recent-details"
  }, [_c('a', {
    attrs: {
      "href": "blog-single.html"
    }
  }, [_c('h4', [_vm._v("\n                      Home Audio Recording\n                      For Everyone\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    02 hours ago\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "single-recent-post d-flex flex-row"
  }, [_c('div', {
    staticClass: "recent-thumb"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/assets/images/r2.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "recent-details"
  }, [_c('a', {
    attrs: {
      "href": "blog-single.html"
    }
  }, [_c('h4', [_vm._v("\n                      Home Audio Recording\n                      For Everyone\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    02 hours ago\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "single-recent-post d-flex flex-row"
  }, [_c('div', {
    staticClass: "recent-thumb"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/assets/images/r3.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "recent-details"
  }, [_c('a', {
    attrs: {
      "href": "blog-single.html"
    }
  }, [_c('h4', [_vm._v("\n                      Home Audio Recording\n                      For Everyone\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    02 hours ago\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "single-recent-post d-flex flex-row"
  }, [_c('div', {
    staticClass: "recent-thumb"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": "static/assets/images/r4.jpg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "recent-details"
  }, [_c('a', {
    attrs: {
      "href": "blog-single.html"
    }
  }, [_c('h4', [_vm._v("\n                      Home Audio Recording\n                      For Everyone\n                    ")])]), _vm._v(" "), _c('p', [_vm._v("\n                    02 hours ago\n                  ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "single-widget category-widget"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Post Archive")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Dec '17")]), _vm._v(" "), _c('span', [_vm._v("37")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Nov '17")]), _vm._v(" "), _c('span', [_vm._v("24")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Oct '17")]), _vm._v(" "), _c('span', [_vm._v("59")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Sep '17")]), _vm._v(" "), _c('span', [_vm._v("29")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Aug '17")]), _vm._v(" "), _c('span', [_vm._v("15")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Jul '17")]), _vm._v(" "), _c('span', [_vm._v("09")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "justify-content-between align-items-center d-flex",
    attrs: {
      "href": "#"
    }
  }, [_c('h6', [_vm._v("Jun '17")]), _vm._v(" "), _c('span', [_vm._v("44")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "single-widget tags-widget"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("Tag Clouds")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Lifestyle")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Art")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Adventure")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Food")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Techlology")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Fashion")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Architecture")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Food")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Technology")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8a0a55be"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/BlogDetails.vue
// module id = 298
// module chunks = 1